export enum AssortmentMovement {
  In = 1,
  Out = 2,
  Both = 3
}

(AssortmentMovement as any).__typeName = 'AssortmentMovement';
